<template>
  <div class="charts" :class="{bgColorEcharts:!!serData.length}">
    <!-- <v-chart v-if="serData.length" :options="options" autoresize ref="chart" id="chart_line"></v-chart>
    <div v-else class="nodata">No data was found</div>-->
    <v-chart v-show="serData.length" :options="options" autoresize ref="chart" id="chart_line"></v-chart>
    <div v-show="!serData.length" class="nodata">No data was found</div>
  </div>
</template>

<script>
/**
 * 使用v-if 当改变条件数据为空时,v-if生效,此时dom被销毁,下面涉及到dom的传递,dom销毁, dom引用undedined
 * 当数据再次渲染 有数据出现的时候, 再次传递的时候,因为import是引用拷贝, getOption有可能使用上一次的dom元素,传入的不生效
 * 就会造成 数据有空变有的时候, 无法获取dom   此原因就是 import模块导入的是引用 不是每次一变更后的值
 * 改为v-show   无论数据为空还是存在 dom从未变过,只是display none
 */
import getOption from "common/js/echarts/barLine";
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    xData: {
      default: () => []
    },

    serData: {
      default: () => []
    }
  },

  data() {
    return {
      options: {}
    };
  },

  computed: {
    ...mapState({
      refush(state) {
        return state.ChartRefush.refush;
      }
    })
  },

  watch: {
    serData(newValue) {
      this.$nextTick(() => {
        const dom = this.$refs.chart;
        // const dom = document.getElementById("chart_line")
        this.options = getOption(this.xData, newValue, [], dom);
      });
    },

    refush(newValue) {
      this.$nextTick(() => {
        // pie切换回来时记录状态设置
        const dom = this.$refs.chart;
        const type = newValue.includes("/") ? newValue.split("/")[0] : "line";

        this.serData.forEach(item => (item.type = type));
        this.options = getOption(this.xData, this.serData, [], dom);
      });
    }
  }
};
</script>

<style scoped>
.charts {
  width: 100%;
  height: 300px;
}
.echarts {
  width: 100%;
  height: 100%;
}
.nodata {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding-top: 100px;
}

@media screen and (max-width: 762px) {
  .charts {
    height: 300px;
  }
}
</style>